module.exports = __webpack_public_path__ + "static/tinapastore_portfolio-8c7ac83d3a0503dc25ae72fa617996c1.pdf";